import { Component } from '@angular/core';
import { ContentAppIframeComponent } from '../../../ui/admin/content-app-iframe/content-app-iframe.component';
import { BreadcrumbsComponent } from '../../../ui/admin/breadcrumbs/breadcrumbs.component';

@Component({
	selector: 'app-content-app',
	standalone: true,
	imports: [ContentAppIframeComponent, BreadcrumbsComponent],
	templateUrl: './content-app.component.html',
	styleUrl: './content-app.component.scss',
})
export class ContentAppComponent {}
